import { useCallback, useState } from 'react';
import { SnackAlertContentProps } from '@silverfort/sf-components/dist/SnackAlert/SnackAlertContent';

export const useSnackAlert = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [snackAlertContent, setSnackAlertContent] = useState<SnackAlertContentProps>();

    const popSnackAlert = useCallback((snackAlertContent: SnackAlertContentProps) => {
        setIsOpen(true);
        setSnackAlertContent(snackAlertContent);
    }, []);

    const dismissSnackAlert = useCallback(() => {
        setIsOpen(false);
    }, []);

    return {
        isOpen,
        snackAlertContent,
        popSnackAlert,
        dismissSnackAlert
    };
};
